import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Unit from "./Unit";

const Units = ({ computeGrades, unitList}) => {
const onChange = e => {
console.log(e.target.value);
}

    return (
      <div className="unit-list">
        <h3>Units</h3>
        {unitList.map((unit, index) => (
          <Unit computeGrades = {computeGrades} key={index}  />
        ))}
      </div>
    );
  

};

Units.propTypes = {};

export default Units;
